import "./Agents.css";
import React, { Fragment, useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";

// Form Validate imports Start
import { isValidPhoneNumber } from "react-phone-number-input";
import PhoneInputWithCountry from "react-phone-number-input/react-hook-form";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
// Form Validate imports End
import NoDataFound from "../../components/Common/NoDataFound/NoDataFound";

// Controllers Start
import CreateAgentForInvitation from "../../controllers/agents/CreateAgentForInvitation";
import GetAllAgentsWithFilters from "../../controllers/agents/GetAllAgentsWithFilters";
import GetAgentRoles from "../../controllers/agents/getAgentRoles";
import DeleteAgent from "../../controllers/agents/DeleteAgent";
// Controllers End

// MUI Start
import Modal from "@mui/material/Modal";
import GetSingleClient from "../../controllers/clients/GetSingleClient";
import ContentLoader from "../../components/Common/ContentLoader/ContentLoader";
import InfiniteScroll from "react-infinite-scroll-component";

import isDuplicatedEmail from "./scripts/isDuplicatedEmail";
import isDuplicatedPhone from "./scripts/isDuplicatedPhone";
import UpdateAgentEmailFlag from "../../controllers/agents/UpdateAgentEmailFlag";
import { ToastSuccessMessages } from "../../controllers/auth/AuthErrorMessages";
import { toast, ToastContainer } from "react-toastify";
import GetSingleAgentData from "../../controllers/agents/GetSingleAgentData";
import UpdateSingleAgent from "../../controllers/agents/UpdateSingleAgent";
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng,
} from "react-places-autocomplete";
import ConfirmationModal from "../../components/Common/ConfirmationModal/ConfirmationModal";
import UpdateAgentStatusToInActive from "../../controllers/agents/UpdateAgentStatusToInActive";
import UpdateAgentStatusToActive from "../../controllers/agents/UpdateAgentStatusToActive";
import UserListCard from "../../components/UserListCard/UserListCard";
import FabButton from "../../components/FabButton/FabButton";

import filterIcon from "../../assets/icons/new-icons/filter.svg";

// MUI End

// Form Validate Schema Start
const schema = yup.object().shape({
  name: yup
    .string()
    .min(3, "Name must have at least 3 characters")
    .max(30, "Name must not be more than 30 characters")
    .required("Name is requried"),
  number: yup.string().required("Phone number is required").nullable(),
  email: yup.string().email("Invalid email"),
  address: yup
    .string()
    .max(500, "Address must not be more than 500 characters")
    .required("Address is requried"),
});
// Form Validate Schema End

// Custom Style If There Are No Agents In Agents DataGrid Table Start
function CustomNoRowsOverlay() {
  return (
    <Fragment>
      <div className="agents-custom-nothing">
        <svg
          style={{ width: "120px", height: "120px" }}
          width="100px"
          height="100px"
          viewBox="0 0 204 243"
          fill="none"
          opacity="0.5"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M20.4531 212.25V235H16.1406L6.46875 219.219V235H2.17188V212.25H6.46875L16.1719 228.047V212.25H20.4531ZM23.7812 226.719V226.391C23.7812 225.151 23.9583 224.01 24.3125 222.969C24.6667 221.917 25.1823 221.005 25.8594 220.234C26.5365 219.464 27.3646 218.865 28.3438 218.438C29.3229 218 30.4375 217.781 31.6875 217.781C32.9583 217.781 34.0833 218 35.0625 218.438C36.0521 218.865 36.8854 219.464 37.5625 220.234C38.2396 221.005 38.7552 221.917 39.1094 222.969C39.4635 224.01 39.6406 225.151 39.6406 226.391V226.719C39.6406 227.948 39.4635 229.089 39.1094 230.141C38.7552 231.182 38.2396 232.094 37.5625 232.875C36.8854 233.646 36.0573 234.245 35.0781 234.672C34.099 235.099 32.9792 235.312 31.7188 235.312C30.4688 235.312 29.349 235.099 28.3594 234.672C27.3698 234.245 26.5365 233.646 25.8594 232.875C25.1823 232.094 24.6667 231.182 24.3125 230.141C23.9583 229.089 23.7812 227.948 23.7812 226.719ZM27.9062 226.391V226.719C27.9062 227.458 27.9792 228.151 28.125 228.797C28.2708 229.443 28.4948 230.01 28.7969 230.5C29.099 230.99 29.4896 231.375 29.9688 231.656C30.4583 231.927 31.0417 232.062 31.7188 232.062C32.3854 232.062 32.9583 231.927 33.4375 231.656C33.9167 231.375 34.3073 230.99 34.6094 230.5C34.9219 230.01 35.151 229.443 35.2969 228.797C35.4427 228.151 35.5156 227.458 35.5156 226.719V226.391C35.5156 225.661 35.4427 224.979 35.2969 224.344C35.151 223.698 34.9219 223.13 34.6094 222.641C34.3073 222.141 33.9115 221.75 33.4219 221.469C32.9427 221.177 32.3646 221.031 31.6875 221.031C31.0208 221.031 30.4479 221.177 29.9688 221.469C29.4896 221.75 29.099 222.141 28.7969 222.641C28.4948 223.13 28.2708 223.698 28.125 224.344C27.9792 224.979 27.9062 225.661 27.9062 226.391ZM60.75 231.406V211H64.9062V235H61.1562L60.75 231.406ZM49.8906 226.75V226.422C49.8906 225.13 50.0365 223.958 50.3281 222.906C50.6302 221.844 51.0677 220.932 51.6406 220.172C52.2135 219.411 52.9062 218.823 53.7188 218.406C54.5417 217.99 55.474 217.781 56.5156 217.781C57.526 217.781 58.4062 217.984 59.1562 218.391C59.9167 218.797 60.5625 219.375 61.0938 220.125C61.6354 220.875 62.0677 221.766 62.3906 222.797C62.7135 223.818 62.9479 224.943 63.0938 226.172V227.062C62.9479 228.26 62.7135 229.359 62.3906 230.359C62.0677 231.359 61.6354 232.234 61.0938 232.984C60.5625 233.724 59.9167 234.297 59.1562 234.703C58.3958 235.109 57.5052 235.312 56.4844 235.312C55.4531 235.312 54.526 235.099 53.7031 234.672C52.8906 234.245 52.1979 233.646 51.625 232.875C51.0625 232.104 50.6302 231.198 50.3281 230.156C50.0365 229.115 49.8906 227.979 49.8906 226.75ZM54.0312 226.422V226.75C54.0312 227.479 54.0938 228.161 54.2188 228.797C54.3438 229.432 54.5469 229.995 54.8281 230.484C55.1094 230.964 55.4688 231.339 55.9062 231.609C56.3542 231.88 56.8958 232.016 57.5312 232.016C58.3438 232.016 59.0104 231.839 59.5312 231.484C60.0625 231.12 60.474 230.625 60.7656 230C61.0573 229.365 61.2448 228.651 61.3281 227.859V225.406C61.2865 224.781 61.1771 224.203 61 223.672C60.8333 223.141 60.5938 222.682 60.2812 222.297C59.9792 221.911 59.6042 221.609 59.1562 221.391C58.7083 221.172 58.1771 221.062 57.5625 221.062C56.9271 221.062 56.3854 221.203 55.9375 221.484C55.4896 221.755 55.125 222.135 54.8438 222.625C54.5625 223.115 54.3542 223.682 54.2188 224.328C54.0938 224.974 54.0312 225.672 54.0312 226.422ZM77.9531 231.406V223.609C77.9531 223.036 77.8542 222.542 77.6562 222.125C77.4583 221.708 77.1562 221.385 76.75 221.156C76.3438 220.927 75.8281 220.812 75.2031 220.812C74.651 220.812 74.1667 220.906 73.75 221.094C73.3438 221.281 73.0312 221.547 72.8125 221.891C72.5938 222.224 72.4844 222.609 72.4844 223.047H68.3438C68.3438 222.349 68.5104 221.688 68.8438 221.062C69.1771 220.427 69.651 219.865 70.2656 219.375C70.8906 218.875 71.6354 218.484 72.5 218.203C73.375 217.922 74.3542 217.781 75.4375 217.781C76.7188 217.781 77.8594 218 78.8594 218.438C79.8698 218.865 80.6615 219.51 81.2344 220.375C81.8177 221.24 82.1094 222.328 82.1094 223.641V231.016C82.1094 231.859 82.1615 232.583 82.2656 233.188C82.3802 233.781 82.5469 234.297 82.7656 234.734V235H78.5625C78.3646 234.573 78.2135 234.031 78.1094 233.375C78.0052 232.708 77.9531 232.052 77.9531 231.406ZM78.5312 224.703L78.5625 227.156H75.9531C75.3073 227.156 74.7396 227.224 74.25 227.359C73.7604 227.484 73.3594 227.672 73.0469 227.922C72.7344 228.161 72.5 228.453 72.3438 228.797C72.1875 229.13 72.1094 229.51 72.1094 229.938C72.1094 230.354 72.2031 230.729 72.3906 231.062C72.5885 231.396 72.8698 231.661 73.2344 231.859C73.6094 232.047 74.0469 232.141 74.5469 232.141C75.276 232.141 75.9115 231.995 76.4531 231.703C76.9948 231.401 77.4167 231.036 77.7188 230.609C78.0208 230.182 78.1823 229.776 78.2031 229.391L79.3906 231.172C79.2448 231.599 79.026 232.052 78.7344 232.531C78.4427 233.01 78.0677 233.458 77.6094 233.875C77.151 234.292 76.599 234.635 75.9531 234.906C75.3073 235.177 74.5573 235.312 73.7031 235.312C72.6094 235.312 71.6302 235.094 70.7656 234.656C69.901 234.219 69.2188 233.62 68.7188 232.859C68.2188 232.099 67.9688 231.234 67.9688 230.266C67.9688 229.37 68.1354 228.578 68.4688 227.891C68.8021 227.203 69.2969 226.625 69.9531 226.156C70.6094 225.677 71.4219 225.318 72.3906 225.078C73.3698 224.828 74.4896 224.703 75.75 224.703H78.5312ZM93.8281 218.094V221.062H84.1406V218.094H93.8281ZM86.7344 213.938H90.875V230.125C90.875 230.625 90.9427 231.01 91.0781 231.281C91.2135 231.552 91.4167 231.734 91.6875 231.828C91.9583 231.922 92.2812 231.969 92.6562 231.969C92.9271 231.969 93.1771 231.953 93.4062 231.922C93.6354 231.891 93.8281 231.859 93.9844 231.828L94 234.922C93.6562 235.036 93.2656 235.13 92.8281 235.203C92.401 235.276 91.9167 235.312 91.375 235.312C90.4479 235.312 89.6354 235.156 88.9375 234.844C88.2396 234.521 87.6979 234.005 87.3125 233.297C86.9271 232.578 86.7344 231.63 86.7344 230.453V213.938ZM105.891 231.406V223.609C105.891 223.036 105.792 222.542 105.594 222.125C105.396 221.708 105.094 221.385 104.688 221.156C104.281 220.927 103.766 220.812 103.141 220.812C102.589 220.812 102.104 220.906 101.688 221.094C101.281 221.281 100.969 221.547 100.75 221.891C100.531 222.224 100.422 222.609 100.422 223.047H96.2812C96.2812 222.349 96.4479 221.688 96.7812 221.062C97.1146 220.427 97.5885 219.865 98.2031 219.375C98.8281 218.875 99.5729 218.484 100.438 218.203C101.312 217.922 102.292 217.781 103.375 217.781C104.656 217.781 105.797 218 106.797 218.438C107.807 218.865 108.599 219.51 109.172 220.375C109.755 221.24 110.047 222.328 110.047 223.641V231.016C110.047 231.859 110.099 232.583 110.203 233.188C110.318 233.781 110.484 234.297 110.703 234.734V235H106.5C106.302 234.573 106.151 234.031 106.047 233.375C105.943 232.708 105.891 232.052 105.891 231.406ZM106.469 224.703L106.5 227.156H103.891C103.245 227.156 102.677 227.224 102.188 227.359C101.698 227.484 101.297 227.672 100.984 227.922C100.672 228.161 100.438 228.453 100.281 228.797C100.125 229.13 100.047 229.51 100.047 229.938C100.047 230.354 100.141 230.729 100.328 231.062C100.526 231.396 100.807 231.661 101.172 231.859C101.547 232.047 101.984 232.141 102.484 232.141C103.214 232.141 103.849 231.995 104.391 231.703C104.932 231.401 105.354 231.036 105.656 230.609C105.958 230.182 106.12 229.776 106.141 229.391L107.328 231.172C107.182 231.599 106.964 232.052 106.672 232.531C106.38 233.01 106.005 233.458 105.547 233.875C105.089 234.292 104.536 234.635 103.891 234.906C103.245 235.177 102.495 235.312 101.641 235.312C100.547 235.312 99.5677 235.094 98.7031 234.656C97.8385 234.219 97.1562 233.62 96.6562 232.859C96.1562 232.099 95.9062 231.234 95.9062 230.266C95.9062 229.37 96.0729 228.578 96.4062 227.891C96.7396 227.203 97.2344 226.625 97.8906 226.156C98.5469 225.677 99.3594 225.318 100.328 225.078C101.307 224.828 102.427 224.703 103.688 224.703H106.469ZM127.141 235H122.984V216.531C122.984 215.26 123.229 214.193 123.719 213.328C124.208 212.453 124.906 211.792 125.812 211.344C126.719 210.896 127.786 210.672 129.016 210.672C129.422 210.672 129.807 210.698 130.172 210.75C130.547 210.802 130.917 210.875 131.281 210.969L131.203 214.109C131.005 214.057 130.786 214.021 130.547 214C130.318 213.979 130.062 213.969 129.781 213.969C129.219 213.969 128.74 214.068 128.344 214.266C127.948 214.464 127.646 214.755 127.438 215.141C127.24 215.516 127.141 215.979 127.141 216.531V235ZM130.562 218.094V221.062H120.438V218.094H130.562ZM132.375 226.719V226.391C132.375 225.151 132.552 224.01 132.906 222.969C133.26 221.917 133.776 221.005 134.453 220.234C135.13 219.464 135.958 218.865 136.938 218.438C137.917 218 139.031 217.781 140.281 217.781C141.552 217.781 142.677 218 143.656 218.438C144.646 218.865 145.479 219.464 146.156 220.234C146.833 221.005 147.349 221.917 147.703 222.969C148.057 224.01 148.234 225.151 148.234 226.391V226.719C148.234 227.948 148.057 229.089 147.703 230.141C147.349 231.182 146.833 232.094 146.156 232.875C145.479 233.646 144.651 234.245 143.672 234.672C142.693 235.099 141.573 235.312 140.312 235.312C139.062 235.312 137.943 235.099 136.953 234.672C135.964 234.245 135.13 233.646 134.453 232.875C133.776 232.094 133.26 231.182 132.906 230.141C132.552 229.089 132.375 227.948 132.375 226.719ZM136.5 226.391V226.719C136.5 227.458 136.573 228.151 136.719 228.797C136.865 229.443 137.089 230.01 137.391 230.5C137.693 230.99 138.083 231.375 138.562 231.656C139.052 231.927 139.635 232.062 140.312 232.062C140.979 232.062 141.552 231.927 142.031 231.656C142.51 231.375 142.901 230.99 143.203 230.5C143.516 230.01 143.745 229.443 143.891 228.797C144.036 228.151 144.109 227.458 144.109 226.719V226.391C144.109 225.661 144.036 224.979 143.891 224.344C143.745 223.698 143.516 223.13 143.203 222.641C142.901 222.141 142.505 221.75 142.016 221.469C141.536 221.177 140.958 221.031 140.281 221.031C139.615 221.031 139.042 221.177 138.562 221.469C138.083 221.75 137.693 222.141 137.391 222.641C137.089 223.13 136.865 223.698 136.719 224.344C136.573 224.979 136.5 225.661 136.5 226.391ZM161.297 230.984V218.094H165.453V235H161.547L161.297 230.984ZM161.828 227.484L163.109 227.453C163.109 228.589 162.984 229.635 162.734 230.594C162.484 231.552 162.094 232.385 161.562 233.094C161.042 233.792 160.38 234.339 159.578 234.734C158.776 235.12 157.828 235.312 156.734 235.312C155.901 235.312 155.141 235.198 154.453 234.969C153.766 234.729 153.172 234.359 152.672 233.859C152.182 233.349 151.802 232.698 151.531 231.906C151.26 231.104 151.125 230.141 151.125 229.016V218.094H155.25V229.047C155.25 229.609 155.312 230.078 155.438 230.453C155.573 230.828 155.755 231.135 155.984 231.375C156.224 231.604 156.5 231.771 156.812 231.875C157.135 231.969 157.479 232.016 157.844 232.016C158.844 232.016 159.63 231.818 160.203 231.422C160.786 231.016 161.203 230.474 161.453 229.797C161.703 229.109 161.828 228.339 161.828 227.484ZM173.156 221.703V235H169.031V218.094H172.906L173.156 221.703ZM172.5 225.938H171.281C171.292 224.708 171.458 223.594 171.781 222.594C172.104 221.594 172.557 220.734 173.141 220.016C173.734 219.297 174.438 218.745 175.25 218.359C176.062 217.974 176.969 217.781 177.969 217.781C178.781 217.781 179.516 217.896 180.172 218.125C180.828 218.354 181.391 218.719 181.859 219.219C182.339 219.719 182.703 220.375 182.953 221.188C183.214 221.99 183.344 222.979 183.344 224.156V235H179.188V224.125C179.188 223.354 179.073 222.745 178.844 222.297C178.625 221.849 178.302 221.531 177.875 221.344C177.458 221.156 176.943 221.062 176.328 221.062C175.693 221.062 175.135 221.193 174.656 221.453C174.188 221.703 173.792 222.052 173.469 222.5C173.156 222.948 172.917 223.464 172.75 224.047C172.583 224.63 172.5 225.26 172.5 225.938ZM197.125 231.406V211H201.281V235H197.531L197.125 231.406ZM186.266 226.75V226.422C186.266 225.13 186.411 223.958 186.703 222.906C187.005 221.844 187.443 220.932 188.016 220.172C188.589 219.411 189.281 218.823 190.094 218.406C190.917 217.99 191.849 217.781 192.891 217.781C193.901 217.781 194.781 217.984 195.531 218.391C196.292 218.797 196.938 219.375 197.469 220.125C198.01 220.875 198.443 221.766 198.766 222.797C199.089 223.818 199.323 224.943 199.469 226.172V227.062C199.323 228.26 199.089 229.359 198.766 230.359C198.443 231.359 198.01 232.234 197.469 232.984C196.938 233.724 196.292 234.297 195.531 234.703C194.771 235.109 193.88 235.312 192.859 235.312C191.828 235.312 190.901 235.099 190.078 234.672C189.266 234.245 188.573 233.646 188 232.875C187.438 232.104 187.005 231.198 186.703 230.156C186.411 229.115 186.266 227.979 186.266 226.75ZM190.406 226.422V226.75C190.406 227.479 190.469 228.161 190.594 228.797C190.719 229.432 190.922 229.995 191.203 230.484C191.484 230.964 191.844 231.339 192.281 231.609C192.729 231.88 193.271 232.016 193.906 232.016C194.719 232.016 195.385 231.839 195.906 231.484C196.438 231.12 196.849 230.625 197.141 230C197.432 229.365 197.62 228.651 197.703 227.859V225.406C197.661 224.781 197.552 224.203 197.375 223.672C197.208 223.141 196.969 222.682 196.656 222.297C196.354 221.911 195.979 221.609 195.531 221.391C195.083 221.172 194.552 221.062 193.938 221.062C193.302 221.062 192.76 221.203 192.312 221.484C191.865 221.755 191.5 222.135 191.219 222.625C190.938 223.115 190.729 223.682 190.594 224.328C190.469 224.974 190.406 225.672 190.406 226.422Z"
            fill="#4E36A8"
          />
          <rect
            x="164.797"
            y="1.79248"
            width="4.96046"
            height="20.7479"
            rx="2.48023"
            transform="rotate(20.2658 164.797 1.79248)"
            fill="#4E36A8"
          />
          <rect
            x="148.188"
            y="0.635742"
            width="4.96046"
            height="20.7479"
            rx="2.48023"
            transform="rotate(-7.36432 148.188 0.635742)"
            fill="#4E36A8"
          />
          <rect
            x="179.252"
            y="9.79053"
            width="4.96046"
            height="20.7479"
            rx="2.48023"
            transform="rotate(48.0092 179.252 9.79053)"
            fill="#4E36A8"
          />
          <path
            d="M99.9771 160.001C81.274 159.917 54.3376 165.083 45.1831 166.959C44.2171 167.157 44.1342 168.47 45.0541 168.825C87.2923 185.138 111.939 184.978 152.998 168.826C153.912 168.467 153.822 167.161 152.86 166.962C143.955 165.118 118.017 160.082 99.9771 160.001Z"
            fill="#4E36A8"
            fillOpacity="0.27"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M41.8864 47.9755H160.295C161.65 47.9755 162.901 48.5261 163.816 49.5245C164.732 50.523 165.172 51.8174 165.054 53.1674L161.163 97.7624C165.486 99.2532 173.307 105.389 176.634 119.076C179.576 119.082 181.958 121.467 181.958 124.41C181.958 127.355 179.57 129.743 176.625 129.743C173.679 129.743 171.292 127.355 171.292 124.41C171.292 122.156 172.69 120.228 174.667 119.447C171.598 106.933 164.687 101.359 160.982 99.832L159.258 119.59C159.041 122.076 156.996 123.951 154.5 123.951H49.2419C46.8033 123.951 44.7627 122.123 44.494 119.7L42.3264 100.126C38.5112 102.004 32.1891 107.632 29.2915 119.447C31.2682 120.228 32.6667 122.156 32.6667 124.41C32.6667 127.355 30.2789 129.743 27.3333 129.743C24.3878 129.743 22 127.355 22 124.41C22 121.467 24.3827 119.082 27.3239 119.076C30.4783 106.1 37.6721 99.911 42.0946 98.0327L37.1385 53.2779C36.9871 51.9098 37.4095 50.5921 38.3275 49.5665C39.246 48.5402 40.5098 47.9755 41.8864 47.9755ZM158.734 39.4708V28.9617C158.734 26.6127 157.303 24.7292 154.954 24.7292H107.705V23.4019C107.705 16.4739 103.07 11.1216 96.7908 11.1216H54.3618C48.083 11.1216 42.5022 16.4739 42.5022 23.4019V37.5487C42.5022 38.234 42.8739 38.874 43.2024 39.4396L43.2205 39.4708H158.734ZM84.4836 124.41V151.62L77.3233 166.62H94.6439L87.4836 151.62V124.41H84.4836ZM111.143 124.41V151.62L103.983 166.62H121.303L114.143 151.62V124.41H111.143Z"
            fill="#4E36A8"
          />
          <path
            d="M84.856 79.5601C86.5231 79.5601 88.1219 78.9279 89.3007 77.8027C90.4795 76.6775 91.1417 75.1514 91.1417 73.5601C91.1417 71.9688 90.4795 70.4426 89.3007 69.3174C88.1219 68.1922 86.5231 67.5601 84.856 67.5601C83.189 67.5601 81.5902 68.1922 80.4114 69.3174C79.2326 70.4426 78.5703 71.9688 78.5703 73.5601C78.5703 75.1514 79.2326 76.6775 80.4114 77.8027C81.5902 78.9279 83.189 79.5601 84.856 79.5601ZM122.57 73.5601C122.57 75.1514 121.908 76.6775 120.729 77.8027C119.55 78.9279 117.952 79.5601 116.285 79.5601C114.618 79.5601 113.019 78.9279 111.84 77.8027C110.661 76.6775 109.999 75.1514 109.999 73.5601C109.999 71.9688 110.661 70.4426 111.84 69.3174C113.019 68.1922 114.618 67.5601 116.285 67.5601C117.952 67.5601 119.55 68.1922 120.729 69.3174C121.908 70.4426 122.57 71.9688 122.57 73.5601Z"
            fill="white"
          />
          <ellipse cx="88.0703" cy="75.5601" rx="2.5" ry="3" fill="#D9D9D9" />
          <ellipse cx="119.07" cy="75.5601" rx="2.5" ry="3" fill="#D9D9D9" />
          <path
            d="M85.5703 97.5601C96.5703 88.2268 108.01 88.2268 118.57 97.5601"
            stroke="white"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </div>
    </Fragment>
  );
}
// Custom Style If There Are No Agents In Agents DataGrid Table End

const AGENTS_LIMIT_PER_PACKET = 10;
let unsubscribe;

const Agents = () => {
  // Form Validate const Start
  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    control,
    setError,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(schema),
  });
  // Form Validate const End

  const [isDisabled, setIsDisabled] = useState(false);
  const [Agents, setAgents] = useState([]);

  const [agentRoles, setAgentRoles] = useState(null);
  const [Refresh, setRefresh] = useState(true);
  const [refreshAgentDelete, setRefreshAgentDelete] = useState(false);
  const [refreshAgentStatus, setRefreshAgentStatus] = useState(false);
  const [refreshDOM, setRefreshDOM] = useState(false);
  const [RequestingAgents, setRequestingAgents] = useState(true);

  const [searchValue, setSearchValue] = useState("");

  // Modal Start
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setValue("name", "");
    setValue("number", "");
    setValue("email", "");
    setValue("address", "");
    setAddress("");
    setError("email", {
      message: "",
    });
    setError("number", {
      message: "",
    });
    setOpen(false);
  };
  // Modal End

  const navigate = useNavigate();
  const location = useLocation();

  // Get All Leads useEffect Start
  const [hasMore, setHasMore] = useState(true);
  const [Year, setYear] = useState("*");
  const [Filter, setFilter] = useState("*");
  const [ActiveTab, setActiveTab] = useState("*");
  const LastSnapshot = useRef("*");

  const fetchAgents = async (bottomFetching = true) => {
    const agentRole = await GetAgentRoles();
    setAgentRoles(agentRole.module_access);

    const agentsArr = await GetAllAgentsWithFilters(
      Year,
      Filter,
      LastSnapshot.current,
      AGENTS_LIMIT_PER_PACKET
    );

    if (agentsArr.agents.length < AGENTS_LIMIT_PER_PACKET) setHasMore(false);

    LastSnapshot.current =
      agentsArr.agentsSnapshot.docs[agentsArr.agentsSnapshot.docs.length - 1];

    if (bottomFetching) setAgents([...Agents, ...agentsArr.agents]);
    else setAgents([...agentsArr.agents]);
    setRequestingAgents(false);
  };

  const handleRefresh = () => {
    LastSnapshot.current = "*";
    setAgents([]);
    setRefresh(!Refresh);
  };

  useEffect(() => {
    fetchAgents(false);
    setRequestingAgents(true);
  }, [Refresh, refreshAgentDelete, Year, Filter, refreshAgentStatus]);
  useEffect(
    () => handleRefresh(),
    [refreshAgentDelete, Year, Filter, refreshAgentStatus]
  );

  // // side effect for listening to real time updates

  // Get All Leads useEffect Start
  const [clientYear, setClientYear] = useState("*");
  useEffect(() => {
    async function fetchData() {
      const client = await GetSingleClient();
      let clientCreatedAt = client.createdAt;
      clientCreatedAt = new Date(clientCreatedAt.toDate());
      setClientYear(clientCreatedAt);
    }
    fetchData();
  }, [refreshAgentDelete, Refresh, refreshAgentStatus]);
  // Get All Leads useEffect End

  // Invite Start
  const [InviteDialog, setInviteDialog] = useState(false);
  const [InviteAgentId, setInviteAgentId] = useState("");

  const handleOpenInviteDialog = (id) => {
    setInviteAgentId(id);
    setInviteDialog(true);
  };

  const handleCloseInviteDialog = (invite) => {
    setInviteDialog(false);
    if (invite === true) {
      handleAgentInvite(InviteAgentId);
      setInviteDialog(false);
    }
  };

  const handleAgentInvite = async (id) => {
    toast.info("Invite resend successfully", {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    await UpdateAgentEmailFlag(id);
  };
  // Invite End

  // Active Start
  const [ActiveDialog, setActiveDialog] = useState(false);
  const [ActiveAgentId, setActiveAgentId] = useState("");
  const handleOpenActveDialog = (id) => {
    setActiveAgentId(id);
    setActiveDialog(true);
  };
  const handleCloseActiveDialog = async (active) => {
    setActiveDialog(false);
    if (active === true) {
      await UpdateAgentStatusToInActive(ActiveAgentId);
      setRefreshAgentStatus(!refreshAgentStatus);
      setActiveDialog(false);
    }
  };
  // Active End

  // In Active Start
  const [InActiveDialog, setInActiveDialog] = useState(false);
  const [InActiveAgentId, setInActiveAgentId] = useState("");
  const handleOpenInActveDialog = (id) => {
    setInActiveAgentId(id);
    setInActiveDialog(true);
  };
  const handleCloseInActiveDialog = async (active) => {
    setInActiveDialog(false);
    if (active === true) {
      await UpdateAgentStatusToActive(InActiveAgentId);
      setRefreshAgentStatus(!refreshAgentStatus);
      setInActiveDialog(false);
    }
  };
  // In Active End

  // Delete Start
  const [DeleteDialog, setDeleteDialog] = useState(false);
  const [DeleteAgentId, setDeleteAgentId] = useState("");
  const handleOpenDeleteDialog = (id) => {
    setDeleteAgentId(id);
    setDeleteDialog(true);
  };
  const handleCloseDeleteDialog = async (del) => {
    setDeleteDialog(false);
    if (del === true) {
      await DeleteAgent(DeleteAgentId);
      setRefreshAgentDelete(!refreshAgentDelete);
      setDeleteDialog(false);
    }
  };
  // Delete End

  const [ButtonLoader, setButtonLoader] = useState(false);
  const [address, setAddress] = useState("");
  const handleSelect = async (value) => {
    setAddress(value);
    setValue("address", value);
  };
  const submitForm = async (e) => {
    setIsDisabled(true);
    setButtonLoader(true);
    if (e.number !== "" || e.number !== null || e.number !== undefined) {
      if (isValidPhoneNumber(e.number)) {
        //checking for duplicates
        if (await isDuplicatedPhone(e.number)) {
          setError("number", {
            message:
              "This phone number already exists! use a different phone number ",
          });
          setIsDisabled(false);
          setButtonLoader(false);
          return;
        }
      } else {
        setError("number", {
          message: "Enter a valid phone number",
        });
        setIsDisabled(false);
        return;
      }
    }

    if (e.email !== "" && (await isDuplicatedEmail(e.email))) {
      setError("email", {
        message: "Email already exists! Use different email",
      });
      setIsDisabled(false);
      setButtonLoader(false);
      return;
    }
    setIsDisabled(true);
    const formData = {
      name: e.name,
      number: e.number,
      email: e.email,
      address: e.address,
      email_sent: e.email === "",
      module_access: {
        other_properties_permission: e.other_properties_permission,
      },
    };
    const agent = await CreateAgentForInvitation(formData);
    if (agent) {
      reset();
      setIsDisabled(false);
      handleRefresh();
      ToastSuccessMessages("agent/creation-successful");
    } else setIsDisabled(false);
    handleClose();
    // handleCloseModal();
  };

  const [SingleAgentData, setSingleAgentData] = useState({});
  const [AgentId, setAgentId] = useState("");
  const [OpenUpdateModal, setOpenUpdateModal] = useState(false);

  const handleOpenUpdateModal = async (id) => {
    setAgentId(id);
    const agentData = await GetSingleAgentData(id);

    setSingleAgentData(agentData);
    setValue("name", agentData.name);
    setValue("number", agentData.number);
    setValue("email", agentData.email);
    setValue("address", agentData.address);
    setAddress(agentData.address);

    setOpenUpdateModal(true);
  };

  const handleCloseUpdateModal = () => {
    setValue("name", "");
    setValue("number", "");
    setValue("email", "");
    setValue("address", "");
    setError("email", {
      message: "",
    });
    setError("number", {
      message: "",
    });
    setOpenUpdateModal(false);
  };

  const handleUpdateForm = async (e) => {
    setIsDisabled(true);
    setButtonLoader(true);

    if (e.number !== "" || e.number !== null || e.number !== undefined) {
      if (isValidPhoneNumber(e.number)) {
        //checking for duplicates
        if (e.number !== SingleAgentData?.number) {
          if (await isDuplicatedPhone(e.number)) {
            setError("number", {
              message:
                "This phone number already exists! use a different phone number ",
            });
            setIsDisabled(false);
            setButtonLoader(false);
            return;
          }
        }
      } else {
        setError("number", {
          message: "Enter a valid phone number",
        });
        setIsDisabled(false);
        return;
      }
    }
    if (e.email !== "" && e.email !== SingleAgentData.email) {
      if (await isDuplicatedEmail(e.email, AgentId)) {
        setError("email", {
          message: "Email already exists! Use different email",
        });
        setIsDisabled(false);
        setButtonLoader(false);
        return;
      }
    }

    const formData = {
      name: e.name,
      number: e.number,
      email: e.email,
      address: e.address,
      email_sent: e.email === "",
      module_access: {
        other_properties_permission: e.other_properties_permission,
      },
    };
    const agent = await UpdateSingleAgent(formData, AgentId);
    if (agent !== null) {
      reset();
      setIsDisabled(false);
      handleRefresh();
      ToastSuccessMessages("agent/updating-successful");
    }
    handleCloseUpdateModal();
  };

  //Check that is it mobile screen
  const [isMobile, setIsMobile] = useState(false);
  const setWindowDimensions = () => {
    if (window.innerWidth < 768) {
      setIsMobile(true);
    } else {
      setIsMobile(false);
    }
  };

  useEffect(() => {
    window.addEventListener("resize", setWindowDimensions);
    setWindowDimensions();
    return () => {
      window.removeEventListener("resize", setWindowDimensions);
    };
  }, []);

  return (
    <Fragment>
      {isMobile && (
        <FabButton
          onClick={() => {
            handleOpen("add", "");
          }}
        />
      )}
      <div className="global-body-container agents-listing">
        {isMobile ? (
          <div>
            <div class="custom-heading">Agents</div>
            <div className="agents-header-bar">
              <div className="search-bar">
                <div className="input-group">
                  <input
                    type="search"
                    className="agents-search-input"
                    placeholder="Enter name or mobile number"
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    className="search-icon d-none d-xl-block"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
                      fill="#929292"
                    />
                  </svg>
                </div>
              </div>
              {!isMobile && (
                <button
                  className="add-agents-button"
                  onClick={() => {
                    handleOpen("add", "");
                  }}
                >
                  <svg
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M12 17V7"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                    <path
                      d="M7 12H17"
                      stroke="white"
                      stroke-width="3"
                      stroke-linecap="round"
                    />
                  </svg>{" "}
                  Add agent
                </button>
              )}
              {/* 

              <div className="agents-filter">
                <img src={filterIcon} />
              </div>

               */}
            </div>

            <div className="agent-tab-container">
              <button
                onClick={() => {
                  setFilter("*");
                  setActiveTab("*");
                }}
                className={`agent-filter-button ${
                  ActiveTab === "*" ? " agent-filter-button-active" : ""
                }`}
              >
                All
              </button>
              <button
                onClick={() => {
                  setFilter("active");
                  setActiveTab("active");
                }}
                className={`agent-filter-button ${
                  ActiveTab === "active" ? " agent-filter-button-active" : ""
                }`}
              >
                Active
              </button>
              <button
                onClick={() => {
                  setFilter("inactive");
                  setActiveTab("inactive");
                }}
                className={`agent-filter-button ${
                  ActiveTab === "inactive" ? " agent-filter-button-active" : ""
                }`}
              >
                Inactive
              </button>
              <button
                onClick={() => {
                  setFilter("pending");
                  setActiveTab("pending");
                }}
                className={`agent-filter-button ${
                  ActiveTab === "pending" ? " agent-filter-button-active" : ""
                }`}
              >
                Pending
              </button>
            </div>
          </div>
        ) : (
          <>
            <h3 className="custom-heading">Agents</h3>
            <div className="agents-header-bar " id="flex-none">
              <div className="links-style ">
                <a
                  href="#"
                  className={`link-tab ${
                    ActiveTab === "*" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("*");
                    setActiveTab("*");
                  }}
                >
                  All
                </a>
                <a
                  href="#"
                  className={`link-tab ${
                    ActiveTab === "active" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("active");
                    setActiveTab("active");
                  }}
                >
                  Active
                </a>
                <a
                  href="#"
                  className={`link-tab ${
                    ActiveTab === "inactive" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("inactive");
                    setActiveTab("inactive");
                  }}
                >
                  Inactive
                </a>
                <a
                  href="#"
                  className={`link-tab ${
                    ActiveTab === "pending" ? "active-tab" : ""
                  }`}
                  onClick={() => {
                    setFilter("pending");
                    setActiveTab("pending");
                  }}
                >
                  Pending
                </a>
              </div>

              <div className="search-bar ">
                <div className="input-group">
                  <input
                    type="search"
                    className="agents-search-input"
                    placeholder="Enter name or mobile number"
                    onChange={(e) => {
                      setSearchValue(e.target.value);
                    }}
                  />
                  <svg
                    width="20"
                    height="21"
                    viewBox="0 0 20 21"
                    fill="none"
                    className="search-icon d-none d-xl-block"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M19.1592 16.0701L15.7962 12.7027C16.3057 11.5803 16.6115 10.4578 16.6115 9.2333C16.6115 6.98843 15.7962 4.94761 14.1656 3.417C10.9045 0.15169 5.70701 0.15169 2.44586 3.417C-0.815288 6.6823 -0.815288 11.8864 2.44586 15.1517C3.97452 16.6823 6.11465 17.6007 8.2548 17.6007C9.4777 17.6007 10.7006 17.2945 11.7197 16.7843L15.0828 20.1517C15.5924 20.6619 16.4076 20.968 17.121 20.968C17.8344 20.968 18.5478 20.6619 19.1592 20.1517C20.2803 18.9272 20.2803 17.0905 19.1592 16.0701ZM3.87261 13.519C1.42675 11.0701 1.42675 7.09047 3.87261 4.74353C5.09554 3.51904 6.6242 2.90679 8.2548 2.90679C9.8854 2.90679 11.414 3.51904 12.6369 4.74353C13.8599 5.96802 14.4713 7.49863 14.4713 9.1313C14.4713 10.7639 13.8599 12.3966 12.6369 13.519C11.414 14.6415 9.8854 15.3558 8.2548 15.3558C6.6242 15.3558 4.99363 14.7435 3.87261 13.519Z"
                      fill="#929292"
                    />
                  </svg>
                </div>
              </div>
              <button className="add-agents-button" onClick={handleOpen}>
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M12 17V7"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                  <path
                    d="M7 12H17"
                    stroke="white"
                    stroke-width="3"
                    stroke-linecap="round"
                  />
                </svg>
                Add Agent
              </button>
            </div>
          </>
        )}

        <div className="row">
          <div className="col-12 ">
            <div className="table-responsive table-stripedd table-hoverr mt-2">
              {!RequestingAgents && (
                <Fragment>
                  <InfiniteScroll
                    dataLength={Agents.length} //This is important field to render the next data
                    next={fetchAgents}
                    hasMore={hasMore}
                    loader={
                      <div className="global-body-container h-100">
                        <div className="sk-three-bounce">
                          <div className="sk-child sk-bounce1"></div>
                          <div className="sk-child sk-bounce2"></div>
                          <div className="sk-child sk-bounce3"></div>
                        </div>
                      </div>
                    }
                    scrollThreshold={1.05}
                  >
                    {isMobile ? (
                      Agents.filter((e) => {
                        if (searchValue == "") {
                          return e;
                        } else {
                          return (
                            e.name.toLowerCase().includes(searchValue) ||
                            e.number.includes(searchValue)
                          );
                        }
                      }).map((agent) => {
                        return (
                          <UserListCard
                            name={agent.name}
                            date={agent?.createdAt
                              ?.toDate()
                              ?.toLocaleString("en-GB", {
                                year: "numeric",
                                month: "short",
                                day: "numeric",
                              })}
                            phone={agent.number}
                            email={agent.email}
                            cnic={agent.cnic}
                            address={agent.address}
                            handleOpenInActveDialog={() => {
                              handleOpenInActveDialog(agent?.id);
                            }}
                            handleCloseInActiveDialog={() => {
                              handleCloseInActiveDialog(agent?.status);
                            }}
                            handleOpenActveDialog={() => {
                              handleOpenActveDialog(agent?.id);
                            }}
                            status={agent.status}
                            onEdit={() => {
                              handleOpenUpdateModal(agent?.id);
                            }}
                            onClick={() =>
                              navigate(`/user/agents/details/${agent.id}`)
                            }
                            onInvite={() => handleOpenInviteDialog(agent?.id)}
                            onDelete={() => {
                              handleOpenDeleteDialog(agent.id);
                            }}
                          />
                        );
                      })
                    ) : (
                      <table className="table table-borderless ">
                        <thead>
                          <tr>
                            <th scope="col" className="agent-name ">
                              <span
                                className="agent-name-padding"
                                style={{
                                  fontWeight: 500,
                                }}
                              >
                                {" "}
                                Name{" "}
                              </span>
                              {/* <svg
                                className="svg-margin-left"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                  fill="#404040"
                                  stroke="#404040"
                                />
                              </svg> */}
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Mobile
                              {/* <svg
                                className="svg-margin-left"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                  fill="#404040"
                                  stroke="#404040"
                                />
                              </svg> */}
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Email
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Address
                              {/* <svg
                                className="svg-margin-left"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M5.25 3.8107L2.5303 6.5303C2.2374 6.8232 1.7626 6.8232 1.4697 6.5303C1.1768 6.2374 1.1768 5.7626 1.4697 5.4697L5.4697 1.4697C5.7626 1.1768 6.2374 1.1768 6.5303 1.4697L10.5303 5.4697C10.8232 5.7626 10.8232 6.2374 10.5303 6.5303C10.2374 6.8232 9.76256 6.8232 9.46967 6.5303L6.75 3.8107L6.75 13.5C6.75 13.9142 6.4142 14.25 6 14.25C5.5858 14.25 5.25 13.9142 5.25 13.5L5.25 3.8107Z"
                                  fill="#404040"
                                  stroke="#404040"
                                />
                              </svg> */}
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Status
                              {/* <svg
                                className="svg-margin-left"
                                width="12"
                                height="15"
                                viewBox="0 0 12 15"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <path
                                  d="M6.75 11.1893L9.4697 8.4697C9.7626 8.1768 10.2374 8.1768 10.5303 8.4697C10.8232 8.7626 10.8232 9.2374 10.5303 9.5303L6.5303 13.5303C6.2374 13.8232 5.7626 13.8232 5.4697 13.5303L1.46967 9.5303C1.17678 9.2374 1.17678 8.7626 1.46967 8.4697C1.76256 8.1768 2.23744 8.1768 2.53033 8.4697L5.25 11.1893V1.5C5.25 1.08579 5.5858 0.75 6 0.75C6.4142 0.75 6.75 1.08579 6.75 1.5V11.1893Z"
                                  fill="#404040"
                                  stroke="#404040"
                                />
                              </svg> */}
                            </th>
                            <th
                              scope="col"
                              style={{
                                fontWeight: 500,
                              }}
                            >
                              Action
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {Agents &&
                            Agents.filter((e) => {
                              if (searchValue == "") {
                                return e;
                              } else {
                                return (
                                  e.name.toLowerCase().includes(searchValue) ||
                                  e.number.includes(searchValue)
                                );
                              }
                            }).map((agent) => {
                              return (
                                <Fragment>
                                  <tr
                                    onClick={() =>
                                      navigate(
                                        `/user/agents/details/${agent?.id}`
                                      )
                                    }
                                  >
                                    <th
                                      className={`border-radius-left ${
                                        agent?.status === "active"
                                          ? "active-border"
                                          : agent?.status === "inactive"
                                          ? "inactive-border"
                                          : "pending-border"
                                      }`}
                                      scope="row"
                                    >
                                      {agent?.name}
                                      {/* <small className="status">Buyer</small> */}
                                      <br />
                                      <div className="alignment">
                                        <small className="add-on">
                                          Added on:
                                        </small>
                                        <small>
                                          {agent?.createdAt
                                            ?.toDate()
                                            ?.toLocaleString("en-GB", {
                                              year: "numeric",
                                              month: "short",
                                              day: "numeric",
                                            })}
                                        </small>
                                      </div>
                                    </th>
                                    <td>{agent?.number}</td>
                                    <td>
                                      {agent?.email ? agent?.email : "------"}
                                    </td>
                                    <td>{agent?.address}</td>
                                    <td
                                      className={`${
                                        agent?.status === "active"
                                          ? "active-color"
                                          : agent?.status === "inactive"
                                          ? "inactive-color"
                                          : "pending-color"
                                      }`}
                                    >
                                      {`${
                                        agent?.status === "active"
                                          ? "Active"
                                          : agent?.status === "inactive"
                                          ? "In-Active"
                                          : "Pending"
                                      }`}
                                    </td>
                                    <td>
                                      {/* {agent?.status !== "active" && ( */}
                                      <div className="edit-delete-svg">
                                        {agent?.status === "invite" &&
                                          agent?.email !== "" && (
                                            <span
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleOpenInviteDialog(
                                                  agent?.id
                                                );
                                              }}
                                            >
                                              <svg
                                                className="svg-margin-right"
                                                width="35"
                                                height="35"
                                                viewBox="0 0 42 42"
                                                fill="none"
                                                xmlns="http://www.w3.org/2000/svg"
                                              >
                                                <rect
                                                  width="42"
                                                  height="42"
                                                  rx="10"
                                                  fill="#EBEBEB"
                                                />
                                                <path
                                                  d="M28.0248 33.3466C23.3934 33.8643 18.6063 33.8643 13.9751 33.3466C12.2363 33.1523 10.7097 32.212 9.74417 30.8464L21.7499 18.8408L25.4544 22.5452C25.8937 22.9846 26.606 22.9846 27.0454 22.5452C27.4847 22.1059 27.4847 21.3937 27.0454 20.9543L22.5453 16.4543C22.106 16.015 21.3938 16.015 20.9544 16.4543L8.78117 28.6274C8.74757 28.4631 8.72057 28.2962 8.70077 28.1271C8.14697 23.3917 8.14697 18.6079 8.70077 13.8725C9.02312 11.117 11.2355 8.95914 13.9751 8.65284C18.6063 8.13534 23.3934 8.13534 28.0248 8.65284C30.7643 8.95914 32.9767 11.117 33.299 13.8725C33.8528 18.6079 33.8528 23.3917 33.299 28.1271C32.9767 30.8825 30.7643 33.0405 28.0248 33.3466Z"
                                                  fill="#929292"
                                                />
                                                <path
                                                  d="M32.6118 13.9752C33.1294 18.6066 33.1294 23.3937 32.6118 28.0249C32.4174 29.7637 31.4771 31.2903 30.1115 32.2558L18.106 20.2501L21.8104 16.5456C22.2497 16.1063 22.2497 15.394 21.8104 14.9546C21.371 14.5153 20.6588 14.5153 20.2195 14.9546L15.7195 19.4547C15.2801 19.894 15.2801 20.6062 15.7195 21.0456L27.8926 33.2188C27.7282 33.2524 27.5613 33.2794 27.3922 33.2992C22.6568 33.853 17.873 33.853 13.1377 33.2992C10.3822 32.9769 8.22428 30.7645 7.91798 28.0249C7.40047 23.3937 7.40047 18.6066 7.91798 13.9752C8.22428 11.2357 10.3822 9.0233 13.1377 8.70103C17.873 8.14718 22.6568 8.14718 27.3922 8.70103C30.1476 9.0233 32.3056 11.2357 32.6118 13.9752Z"
                                                  fill="#929292"
                                                />
                                                <path
                                                  d="M14.4545 15C13.6545 15 13 15.6632 13 16.4737V25.3158C13 26.1263 13.6545 26.7895 14.4545 26.7895H22.0909C21.8931 26.321 21.7703 25.8235 21.7273 25.3158H14.4545V17.9474L20.2727 21.6316L26.0909 17.9474V20.1579C26.2121 20.1532 26.3334 20.1532 26.4545 20.1579C26.822 20.159 27.1881 20.2035 27.5455 20.2905V16.4737C27.5455 15.6632 26.8909 15 26.0909 15H14.4545ZM14.4545 16.4737H26.0909L20.2727 20.1579L14.4545 16.4737ZM26.0909 20.8947L24.4545 22.5526L26.0909 24.2105V23.1053C26.5731 23.1053 27.0356 23.2993 27.3766 23.6448C27.7175 23.9903 27.9091 24.4588 27.9091 24.9474C27.9091 25.2421 27.8436 25.5221 27.72 25.7726L28.5127 26.5758C28.8182 26.1116 29 25.5516 29 24.9474C29 23.3189 27.6982 22 26.0909 22V20.8947ZM23.6691 23.3189C23.3636 23.7832 23.1818 24.3432 23.1818 24.9474C23.1818 26.5758 24.4836 27.8947 26.0909 27.8947V29L27.7273 27.3421L26.0909 25.6842V26.7895C25.6087 26.7895 25.1462 26.5954 24.8053 26.2499C24.4643 25.9045 24.2727 25.4359 24.2727 24.9474C24.2727 24.6526 24.3382 24.3726 24.4618 24.1221L23.6691 23.3189Z"
                                                  fill="white"
                                                />
                                              </svg>
                                            </span>
                                          )}

                                        {agent?.status === "active" && (
                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenActveDialog(agent?.id);
                                            }}
                                          >
                                            <svg
                                              className="svg-margin-right"
                                              width="35"
                                              height="35"
                                              viewBox="0 0 42 42"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <rect
                                                width="42"
                                                height="42"
                                                rx="10"
                                                fill="#EBEBEB"
                                              />
                                              <g clipPath="url(#clip0_309_4)">
                                                <path
                                                  d="M28.0248 33.3466C23.3934 33.8643 18.6063 33.8643 13.9751 33.3466C12.2363 33.1523 10.7097 32.212 9.74417 30.8464L21.7499 18.8408L25.4544 22.5452C25.8937 22.9846 26.606 22.9846 27.0454 22.5452C27.4847 22.1059 27.4847 21.3937 27.0454 20.9543L22.5453 16.4543C22.106 16.015 21.3938 16.015 20.9544 16.4543L8.78117 28.6274C8.74757 28.4631 8.72057 28.2962 8.70077 28.1271C8.14697 23.3917 8.14697 18.6079 8.70077 13.8725C9.02312 11.117 11.2355 8.95914 13.9751 8.65284C18.6063 8.13534 23.3934 8.13534 28.0248 8.65284C30.7643 8.95914 32.9767 11.117 33.299 13.8725C33.8528 18.6079 33.8528 23.3917 33.299 28.1271C32.9767 30.8825 30.7643 33.0405 28.0248 33.3466Z"
                                                  fill="#B51D1D"
                                                />
                                                <g clipPath="url(#clip1_309_4)">
                                                  <path
                                                    d="M33.3466 13.9752C33.8643 18.6066 33.8643 23.3937 33.3466 28.0249C33.1523 29.7637 32.212 31.2903 30.8464 32.2558L18.8408 20.2501L22.5452 16.5456C22.9846 16.1063 22.9846 15.394 22.5452 14.9546C22.1059 14.5153 21.3937 14.5153 20.9543 14.9546L16.4543 19.4547C16.015 19.894 16.015 20.6062 16.4543 21.0456L28.6274 33.2188C28.4631 33.2524 28.2962 33.2794 28.1271 33.2992C23.3917 33.853 18.6079 33.853 13.8725 33.2992C11.117 32.9769 8.95914 30.7645 8.65284 28.0249C8.13534 23.3937 8.13534 18.6066 8.65284 13.9752C8.95914 11.2357 11.117 9.0233 13.8725 8.70103C18.6079 8.14718 23.3917 8.14718 28.1271 8.70103C30.8825 9.0233 33.0405 11.2357 33.3466 13.9752Z"
                                                    fill="#B51D1D"
                                                  />
                                                  <rect
                                                    x="13"
                                                    y="14"
                                                    width="15"
                                                    height="15"
                                                    fill="#B51D1D"
                                                  />
                                                  <path
                                                    d="M15.1074 26.8925L26.8925 15.1074"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                  />
                                                  <path
                                                    d="M15.1074 15.1074L26.8925 26.8925"
                                                    stroke="white"
                                                    strokeWidth="1.5"
                                                    strokeLinecap="round"
                                                  />
                                                </g>
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_309_4">
                                                  <rect
                                                    width="36"
                                                    height="36"
                                                    fill="white"
                                                    transform="translate(39 39) rotate(-180)"
                                                  />
                                                </clipPath>
                                                <clipPath id="clip1_309_4">
                                                  <rect
                                                    width="36"
                                                    height="36"
                                                    fill="white"
                                                    transform="translate(39 3) rotate(90)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                          </span>
                                        )}

                                        {agent?.status === "inactive" && (
                                          <span
                                            onClick={(e) => {
                                              e.stopPropagation();
                                              handleOpenInActveDialog(
                                                agent?.id
                                              );
                                            }}
                                          >
                                            <svg
                                              width="35"
                                              height="35"
                                              viewBox="0 0 42 42"
                                              fill="none"
                                              xmlns="http://www.w3.org/2000/svg"
                                            >
                                              <rect
                                                width="42"
                                                height="42"
                                                rx="10"
                                                fill="#EBEBEB"
                                              />
                                              <g clipPath="url(#clip0_302_5)">
                                                <path
                                                  d="M28.0249 32.3468C23.3935 32.8645 18.6064 32.8645 13.9752 32.3468C12.2364 32.1525 10.7098 31.2122 9.7443 29.8466L21.75 17.841L25.4545 21.5454C25.8938 21.9848 26.6062 21.9848 27.0455 21.5454C27.4848 21.1061 27.4848 20.3939 27.0455 19.9545L22.5454 15.4545C22.1061 15.0152 21.3939 15.0152 20.9545 15.4545L8.7813 27.6276C8.74769 27.4633 8.72069 27.2964 8.70089 27.1272C8.1471 22.3919 8.1471 17.6081 8.7009 12.8727C9.02325 10.1172 11.2356 7.95932 13.9752 7.65302C18.6064 7.13552 23.3935 7.13552 28.0249 7.65302C30.7645 7.95932 32.9768 10.1172 33.2991 12.8727C33.8529 17.6081 33.8529 22.3919 33.2991 27.1272C32.9768 29.8827 30.7645 32.0407 28.0249 32.3468Z"
                                                  fill="#2D9E11"
                                                />
                                                <g clipPath="url(#clip1_302_5)">
                                                  <path
                                                    d="M33.3469 12.9751C33.8645 17.6065 33.8645 22.3936 33.3469 27.0248C33.1525 28.7636 32.2122 30.2902 30.8466 31.2557L18.8411 19.25L22.5455 15.5455C22.9848 15.1062 22.9848 14.3938 22.5455 13.9545C22.1061 13.5152 21.3939 13.5152 20.9546 13.9545L16.4546 18.4546C16.0152 18.8939 16.0152 19.6061 16.4546 20.0455L28.6277 32.2187C28.4633 32.2523 28.2964 32.2793 28.1273 32.2991C23.3919 32.8529 18.6081 32.8529 13.8728 32.2991C11.1173 31.9768 8.95935 29.7644 8.65305 27.0248C8.13555 22.3936 8.13555 17.6065 8.65305 12.9751C8.95935 10.2355 11.1173 8.02318 13.8728 7.70091C18.6081 7.14706 23.3919 7.14706 28.1273 7.70091C30.8827 8.02318 33.0407 10.2355 33.3469 12.9751Z"
                                                    fill="#2D9E11"
                                                  />
                                                  <rect
                                                    x="13"
                                                    y="13"
                                                    width="15"
                                                    height="15"
                                                    fill="#2D9E11"
                                                  />
                                                  <path
                                                    fillRule="evenodd"
                                                    clipRule="evenodd"
                                                    d="M30.0454 13.9545C30.4848 14.3938 30.4848 15.1062 30.0454 15.5455L19.5454 26.0454C19.1061 26.4848 18.3939 26.4848 17.9545 26.0454L11.9545 20.0454C11.5152 19.6061 11.5152 18.8939 11.9545 18.4545C12.3938 18.0152 13.1062 18.0152 13.5455 18.4545L18.75 23.6589L28.4545 13.9545C28.8939 13.5152 29.6061 13.5152 30.0454 13.9545Z"
                                                    fill="white"
                                                  />
                                                </g>
                                              </g>
                                              <defs>
                                                <clipPath id="clip0_302_5">
                                                  <rect
                                                    width="36"
                                                    height="36"
                                                    fill="white"
                                                    transform="translate(39 38) rotate(-180)"
                                                  />
                                                </clipPath>
                                                <clipPath id="clip1_302_5">
                                                  <rect
                                                    width="36"
                                                    height="36"
                                                    fill="white"
                                                    transform="translate(39 2) rotate(90)"
                                                  />
                                                </clipPath>
                                              </defs>
                                            </svg>
                                          </span>
                                        )}

                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenDeleteDialog(agent?.id);
                                          }}
                                        >
                                          <svg
                                            style={{ marginleft: "5px" }}
                                            width={35}
                                            height={35}
                                            viewBox="0 0 42 42"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <rect
                                              width={42}
                                              height={42}
                                              rx={10}
                                              fill="#EBEBEB"
                                            />
                                            <path
                                              d="M18.7105 12.75L15.543 15.9262M24.293 12.75L27.4605 15.9262"
                                              stroke="#FF0000"
                                              strokeopacity="0.7"
                                              strokeWidth="1.5"
                                              strokeMiterlimit={10}
                                              strokeLinecap="round"
                                              strokeLinejoin="round"
                                            />
                                            <path
                                              d="M12.75 17.8672C12.75 16.2484 13.6162 16.1172 14.6925 16.1172H28.3075C29.3838 16.1172 30.25 16.2484 30.25 17.8672C30.25 19.7484 29.3838 19.6172 28.3075 19.6172H14.6925C13.6162 19.6172 12.75 19.7484 12.75 17.8672Z"
                                              stroke="#FF0000"
                                              strokeopacity="0.7"
                                              strokeWidth="1.5"
                                            />
                                            <path
                                              d="M19.54 23.25V26.3562M23.565 23.25V26.3562M14.0625 19.75L15.2962 27.31C15.5762 29.0075 16.25 30.25 18.7525 30.25H24.0288C26.75 30.25 27.1525 29.06 27.4675 27.415L28.9375 19.75"
                                              stroke="#FF0000"
                                              strokeopacity="0.7"
                                              strokeWidth="1.5"
                                              strokeLinecap="round"
                                            />
                                          </svg>
                                        </span>

                                        <span
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleOpenUpdateModal(agent?.id);
                                          }}
                                        >
                                          <svg
                                            style={{ marginleft: "5px" }}
                                            width={35}
                                            height={35}
                                            viewBox="0 0 42 42"
                                            fill="none"
                                            xmlns="http://www.w3.org/2000/svg"
                                          >
                                            <rect
                                              width={42}
                                              height={42}
                                              rx={10}
                                              fill="#EBEBEB"
                                            />
                                            <path
                                              opacity="0.8"
                                              d="M12.8193 29.4326L12.8174 29.4307C12.7736 29.3871 12.75 29.344 12.75 29.25V26.425C12.75 26.388 12.7564 26.3538 12.7711 26.3172L12.7716 26.3159C12.7821 26.2896 12.7988 26.2619 12.8303 26.2303L22.6 16.4607L25.7893 19.65L16.0197 29.4197C15.9878 29.4516 15.96 29.4683 15.9345 29.4786C15.8967 29.4936 15.8618 29.5 15.825 29.5H13C12.906 29.5 12.8629 29.4764 12.8193 29.4326ZM28.2969 17.1175L25.1138 13.9719L25.9803 13.1053C26.2183 12.8674 26.4965 12.75 26.863 12.75C27.2286 12.75 27.5065 12.8672 27.7447 13.1053L29.1447 14.5053C29.393 14.7536 29.5146 15.0348 29.5254 15.3861C29.5356 15.7204 29.4318 15.9825 29.1947 16.2197L28.2969 17.1175Z"
                                              stroke="black"
                                              strokeopacity="0.8"
                                              strokeWidth="1.5"
                                            />
                                          </svg>
                                        </span>
                                      </div>
                                      {/* )} */}
                                    </td>
                                  </tr>
                                </Fragment>
                              );
                            })}
                        </tbody>
                      </table>
                    )}

                    {isMobile && Agents.length === 0 ? (
                      <div className="mobile-agents-custom-nothing">
                        <NoDataFound />
                      </div>
                    ) : Agents.length === 0 ? (
                      <div className="agents-custom-nothing">
                        <NoDataFound />
                      </div>
                    ) : (
                      ""
                    )}
                  </InfiniteScroll>
                </Fragment>
              )}
              {RequestingAgents && <ContentLoader />}
            </div>
          </div>
        </div>
      </div>
      {/* <!-- Add Agents Popup --> */}
      <Fragment>
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="ModalStyle add-agent-modal"
        >
          <div className="modal-dialog modal-lg">
            <div className="add-agent-modal-content modal-content">
              <div className="modal-header">
                <h3 className="modal-heading">Add Agent</h3>
                <button
                  type="button"
                  className="close add-agent-modal-close-button"
                  onClick={handleClose}
                >
                  <span>&times;</span>
                </button>
              </div>
              <form className="modal-body" onSubmit={handleSubmit(submitForm)}>
                <div className="form-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      autoFocus
                      type="text"
                      name="name"
                      className="form-control form-input-field"
                      {...register("name")}
                      onChange={(e) => {
                        let words = e.target.value.split(" ");
                        for (let i = 0; i < words.length; i++) {
                          words[i] =
                            words[i][0].toUpperCase() +
                            words[i].slice(1).toLowerCase();
                        }
                        setValue("name", words.join(" "));
                      }}
                      disabled={isDisabled}
                    />
                    <p className="errorMessage"> {errors.name?.message} </p>
                  </div>
                </div>

                <div className="form-row phone-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>
                    <PhoneInputWithCountry
                      name="number"
                      className="form-phone-input-field"
                      defaultCountry={"PK"}
                      international={true}
                      countryCallingCodeEditable={false}
                      initialValueFormat="national"
                      smartCaret={true}
                      control={control}
                      disabled={isDisabled}
                      // defaultValue={number}
                      rules={{
                        validate: (value) => isValidPhoneNumber(value),
                        required: true,
                      }}
                    />

                    <p
                      className="errorMessage"
                      style={{
                        marginBottom: "20px",
                      }}
                    >
                      {" "}
                      {errors.number?.message}{" "}
                    </p>
                  </div>
                </div>

                <div className="form-row ">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="form-control form-input-field"
                      {...register("email")}
                      disabled={isDisabled}
                    />
                    <p className="errorMessage"> {errors.email?.message} </p>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Address <span style={{ color: "red" }}>*</span>
                    </label>
                    <div className="div-autocomplete">
                      {" "}
                      <PlacesAutocomplete
                        value={address}
                        onChange={(e) => {
                          setAddress(e);
                          setValue("address", e);
                        }}
                        onSelect={handleSelect}
                        disabled={isDisabled}
                        searchOptions={{
                          componentRestrictions: { country: "pk" },
                        }}
                        // className="input-style"
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            <input
                              className="location-input-style"
                              {...getInputProps({ placeholder: "Address" })}
                            />

                            <div>
                              {loading ? (
                                <div className="loc-auto-complete-content">
                                  loading...
                                </div>
                              ) : null}

                              {suggestions.map((suggestion) => {
                                const style = {
                                  backgroundColor: suggestion.active
                                    ? "#c9c2e4"
                                    : "#fff",
                                };

                                return (
                                  <div
                                    className="loc-auto-complete-content"
                                    {...getSuggestionItemProps(suggestion, {
                                      style,
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div>

                    <p className="errorMessage"> {errors.address?.message} </p>
                  </div>
                </div>

                {agentRoles && (
                  <div>
                    <div className="form-row">
                      <div className="form-row features-property">
                        <div className="form-group properties-feature">
                          <div
                            className="form-row svg-margin-left"
                            key={"other_properties_permission"}
                          >
                            <div className="custom-control custom-checkbox checkbox-success">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={"other_properties_permission"}
                                name={"other_properties_permission"}
                                required=""
                                {...register("other_properties_permission")}
                                disabled={isDisabled}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={"other_properties_permission"}
                              >
                                Agent is allowed to see other properties.
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="mr-3 btn btn-outline-danger light"
                    onClick={handleClose}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="agent-invite-button"
                    disabled={isDisabled && ButtonLoader}
                  >
                    {isDisabled && ButtonLoader && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                    Invite
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </Fragment>
      {/* Agent Update Modal Start */}
      <Fragment>
        <Modal
          open={OpenUpdateModal}
          onClose={handleCloseUpdateModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          className="ModalStyle update-agent-modal"
        >
          <div className="modal-dialog modal-lg">
            <div className="update-agent-modal-content modal-content">
              <div className="modal-header">
                <h3 className="modal-title">Update Agent</h3>
                <button
                  type="button"
                  className="close update-agent-modal-close-button"
                  onClick={handleCloseUpdateModal}
                >
                  <span>&times;</span>
                </button>
              </div>
              <form
                className="modal-body"
                onSubmit={handleSubmit(handleUpdateForm)}
              >
                <div className="form-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Name <span style={{ color: "red" }}>*</span>
                    </label>
                    <input
                      autoFocus
                      type="text"
                      name="name"
                      className="input-style"
                      {...register("name")}
                      onChange={(e) => {
                        let words = e.target.value.split(" ");
                        for (let i = 0; i < words.length; i++) {
                          words[i] =
                            words[i][0].toUpperCase() +
                            words[i].slice(1).toLowerCase();
                        }
                        setValue("name", words.join(" "));
                      }}
                      disabled={isDisabled}
                    />
                    <p className="errorMessage"> {errors.name?.message} </p>
                  </div>
                </div>

                <div className="form-row phone-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Phone <span style={{ color: "red" }}>*</span>
                    </label>
                    <PhoneInputWithCountry
                      name="number"
                      className="input-style"
                      defaultCountry={"PK"}
                      international={true}
                      countryCallingCodeEditable={false}
                      initialValueFormat="national"
                      smartCaret={true}
                      control={control}
                      disabled={isDisabled}
                      defaultValue={SingleAgentData?.number}
                      rules={{
                        validate: (value) => isValidPhoneNumber(value),
                        required: true,
                      }}
                      style={{ border: "none !important" }}
                    />

                    <p
                      className="errorMessage"
                      style={{
                        marginBottom: "20px",
                      }}
                    >
                      {" "}
                      {errors.number?.message}{" "}
                    </p>
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">Email</label>
                    <input
                      type="email"
                      name="email"
                      className="input-style"
                      {...register("email")}
                      onChange={(e) => setValue("email", e.target.value)}
                      disabled={isDisabled}
                    />
                    <p className="errorMessage"> {errors.email?.message} </p>
                  </div>
                </div>

                <div className="form-row ">
                  <div className="form-group col-12">
                    <label className="modal-form-field-label">
                      Address <span style={{ color: "red" }}>*</span>
                    </label>
                    {/* <input
                      type="text"
                      name="address"
                      className="form-control input-style"
                      {...register("address")}
                      onChange={(e) => {
                        setValue(
                          "address",
                          e.target.value.charAt(0).toUpperCase() +
                            e.target.value.slice(1).toLowerCase()
                        );
                      }}
                      disabled={isDisabled}
                    /> */}

                    <div className="div-autocomplete">
                      {" "}
                      <PlacesAutocomplete
                        value={address}
                        onChange={(e) => {
                          setAddress(e);
                          setValue("address", e);
                        }}
                        onSelect={handleSelect}
                        disabled={isDisabled}
                        searchOptions={{
                          componentRestrictions: { country: "pk" },
                        }}
                        // className="input-style"
                      >
                        {({
                          getInputProps,
                          suggestions,
                          getSuggestionItemProps,
                          loading,
                        }) => (
                          <div>
                            <input
                              className="location-input-style"
                              {...getInputProps({ placeholder: "Address" })}
                            />

                            <div>
                              {loading ? (
                                <div className="loc-auto-complete-content">
                                  loading...
                                </div>
                              ) : null}

                              {suggestions.map((suggestion) => {
                                const style = {
                                  backgroundColor: suggestion.active
                                    ? "#c9c2e4"
                                    : "#fff",
                                };

                                return (
                                  <div
                                    className="loc-auto-complete-content"
                                    {...getSuggestionItemProps(suggestion, {
                                      style,
                                    })}
                                  >
                                    {suggestion.description}
                                  </div>
                                );
                              })}
                            </div>
                          </div>
                        )}
                      </PlacesAutocomplete>
                    </div>
                    <p className="errorMessage"> {errors.address?.message} </p>
                  </div>
                </div>

                {agentRoles && (
                  <div>
                    <div className="form-row">
                      <div className="form-row features-property">
                        <div className="form-group properties-feature">
                          <div
                            className="form-row svg-margin-left"
                            key={"other_properties_permission"}
                          >
                            <div className="custom-control custom-checkbox checkbox-success">
                              <input
                                type="checkbox"
                                className="custom-control-input"
                                id={"other_properties_permission"}
                                name={"other_properties_permission"}
                                required=""
                                {...register("other_properties_permission")}
                                disabled={isDisabled}
                              />
                              <label
                                className="custom-control-label"
                                htmlFor={"other_properties_permission"}
                              >
                                Agent is allowed to see other properties.
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                <div className="modal-footer">
                  <button
                    type="button"
                    className="mr-3 btn btn-outline-danger light"
                    onClick={handleCloseUpdateModal}
                  >
                    Cancel
                  </button>
                  <button
                    type="submit"
                    className="update-agent-button"
                    disabled={isDisabled && ButtonLoader}
                  >
                    {isDisabled && ButtonLoader && (
                      <span className="spinner-border spinner-border-sm mr-1"></span>
                    )}
                    Update
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
      </Fragment>
      {/* Agent Update Modal End */}
      {/* <AgentDeleteConfirmation {...{ DeleteDialog, handleCloseDeleteDialog }} /> */}
      {/* <ConfirmationModal {...{ DeleteDialog, handleCloseDeleteDialog }} /> */}
      <ConfirmationModal
        title={"Invite Again"}
        description={
          "This agent is aready invited. Would you like to invite the agent again?"
        }
        openDialog={InviteDialog}
        handleCloseDialog={handleCloseInviteDialog}
      />
      <ConfirmationModal
        title={"Active Status"}
        description={
          "Your agent is currently active. Would you like to make your agent inactive?"
        }
        openDialog={ActiveDialog}
        handleCloseDialog={handleCloseActiveDialog}
      />
      <ConfirmationModal
        title={"In Active Status"}
        description={
          "Your agent is currently inactive. Would you like to make your agent active?"
        }
        openDialog={InActiveDialog}
        handleCloseDialog={handleCloseInActiveDialog}
      />
      <ConfirmationModal
        title={"Delete Confirmation"}
        description={"Are you sure you want to delete this agent?"}
        openDialog={DeleteDialog}
        handleCloseDialog={handleCloseDeleteDialog}
      />
      <ToastContainer />
    </Fragment>
  );
};

export default Agents;
